import axiosInstance from "./axiosInstance";

// Get all student life data
export const getStudentLife = async () => {
  const response = await axiosInstance.get("/sheets/student-life");
  return response.data;
};

// // Create new student life entry
// export const createStudentLife = async (lifeData) => {
//   const response = await axiosInstance.post("/sheets/student-life", lifeData);
//   return response.data;
// };
